import {
  getLeoUuid,
  LeoUUID,
  getString,
  getOptionalString,
} from "@surya-digital/leo-ts-types";

export interface SurveyTranslationTextDTO {
  translationId: string;
  baseLanguageText: string;
  translatedLanguageText?: string | null;
}

export class SurveyTranslationText {
  readonly isSurveyTranslationTextSurveyTranslationText: boolean = true;

  readonly translationId: LeoUUID;
  readonly baseLanguageText: string;
  readonly translatedLanguageText: string | null;


  constructor(
  translationId: LeoUUID, 
  baseLanguageText: string, 
  translatedLanguageText: string | null = null
  ) {
    this.translationId = translationId;
    SurveyTranslationText.validateBaseLanguageText(baseLanguageText);
    this.baseLanguageText = baseLanguageText;
    if ( translatedLanguageText !== undefined && translatedLanguageText !== null) {
      SurveyTranslationText.validateTranslatedLanguageText(translatedLanguageText);
    }
    this.translatedLanguageText = translatedLanguageText;
  }

  static fromDTO(dto: SurveyTranslationTextDTO): SurveyTranslationText {
    const translationId = getLeoUuid(dto, "translationId", InvalidSurveyTranslationTextTranslationIdError);
    const baseLanguageText = getString(dto, "baseLanguageText", InvalidSurveyTranslationTextBaseLanguageTextError);
    const translatedLanguageText = getOptionalString(dto, "translatedLanguageText", InvalidSurveyTranslationTextTranslatedLanguageTextError);
    return new SurveyTranslationText(
      translationId,
      baseLanguageText,
      translatedLanguageText
    );
  }

  toDTO(): SurveyTranslationTextDTO {
    const dto: SurveyTranslationTextDTO = {
        translationId: this.translationId.toDTO(),
        baseLanguageText: this.baseLanguageText,
    };
    if (this.translatedLanguageText !== undefined && this.translatedLanguageText !== null){
      dto.translatedLanguageText = this.translatedLanguageText;
    }
    return dto;
  }
  private static validateBaseLanguageText = (baseLanguageText: string): void => {
    if(baseLanguageText.trim().length === 0) {
      throw new InvalidSurveyTranslationTextBaseLanguageTextNonEmptyError(
        `Attribute baseLanguageText cannot be an empty string.`
      );
    }
  }
  private static validateTranslatedLanguageText = (translatedLanguageText: string): void => {
    if(translatedLanguageText.trim().length === 0) {
      throw new InvalidSurveyTranslationTextTranslatedLanguageTextNonEmptyError(
        `Attribute translatedLanguageText cannot be an empty string.`
      );
    }
  }
  
}

SurveyTranslationText.prototype.toString = function toString(): string {
  return `SurveyTranslationText(translationId='${this.translationId}',baseLanguageText='${this.baseLanguageText}',translatedLanguageText='${this.translatedLanguageText}')`;
};

export class InvalidSurveyTranslationTextError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyTranslationTextError";
  }
}
export class InvalidSurveyTranslationTextTranslationIdError extends InvalidSurveyTranslationTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyTranslationTextTranslationIdError";
  }
}

export class InvalidSurveyTranslationTextBaseLanguageTextError extends InvalidSurveyTranslationTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyTranslationTextBaseLanguageTextError";
  }
}

export class InvalidSurveyTranslationTextBaseLanguageTextNonEmptyError extends InvalidSurveyTranslationTextBaseLanguageTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyTranslationTextBaseLanguageTextNonEmptyError";
  }
}

export class InvalidSurveyTranslationTextTranslatedLanguageTextError extends InvalidSurveyTranslationTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyTranslationTextTranslatedLanguageTextError";
  }
}

export class InvalidSurveyTranslationTextTranslatedLanguageTextNonEmptyError extends InvalidSurveyTranslationTextTranslatedLanguageTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyTranslationTextTranslatedLanguageTextNonEmptyError";
  }
}
